
export const FormatMerchant = (dataMerchant = [], id) => {
  let data = dataMerchant;
  if (!id || !data) {
    return "";
  }
  let array = Array.isArray(data) ? data : [data];

  let merchant = array?.find((o) => o?.id === id);
  return merchant || undefined;
};
